var React = require('react');

function LetterSpacing (props) {
    return React.createElement("svg",props,React.createElement("text",{"fill":"#2F73A7","fontFamily":"WorkSans-Regular, Work Sans","fontSize":"200","letterSpacing":"20"},[React.createElement("tspan",{"x":"12","y":"187","key":0},"Tt"),React.createElement("tspan",{"fill":"#0D3B5E","x":"70","y":"240","fontSize":"150","key":1},"⎵")]));
}

LetterSpacing.defaultProps = {"viewBox":"0 0 256 256","width":"32"};

module.exports = LetterSpacing;

LetterSpacing.default = LetterSpacing;
